import { loadRecaptcha } from "./recaptchaLoader";

const SITE_KEY = process.env.RECAPTCHA_SITE_KEY;

export async function getRecaptchaToken(action: string): Promise<string> {
  if (!SITE_KEY) {
    throw new Error("Missing reCAPTCHA site key");
  }

  await loadRecaptcha(SITE_KEY);

  return window.grecaptcha.execute(SITE_KEY, { action });
}
